var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-3"},[(_vm.getMetabaseReportURL)?_c('div',[_c('iframe',{attrs:{"src":_vm.getMetabaseReportURL,"frameborder":"0","width":"100%","height":"900","allowtransparency":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }